import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "../DiffusionOptionsDesc/DiffusionOptionsDesc.css";

import IpaInputImage from "../../../image/for-style-change/for-about/sch-turban-woman-input-h125.jpeg"
import IpaMaskImage from "../../../image/for-style-change/for-about/sch-turban-woman-mask-h100.jpeg"
// import StepStyleImage from "../../../image/for-style-change/for-about/sch-style-abstract-crop-h100.jpeg";
// import StepOutputImage1 from "../../../image/for-style-change/option-description/step/turban-woman-output-abstract-stp4-h125.jpeg";
// import StepOutputImage2 from "../../../image/for-style-change/option-description/step/turban-woman-output-abstract-stp8-h125.jpeg";

import IpaStyleImage1 from "../../../image/for-style-change/for-about/sch-style-origami-crop-h125.jpeg";
import IpaStyleImage2 from "../../../image/for-style-change/for-about/sch-style-oil-painting-h100.jpeg";
import IpaStyleImage3 from "../../../image/for-style-change/for-about/sch-style-lego-crop-h125.jpeg";
import IpaOutputImage1 from "../../../image/for-style-change/for-about/sch-turban-woman-origami-style-h125.jpeg";
import IpaOutputImage2 from "../../../image/for-style-change/for-about/more-image/turban-woman-output-oil-h125.jpeg";
import IpaOutputImage3 from "../../../image/for-style-change/for-about/more-image/turban-woman-output-lego-h125.jpeg";

import IpaStyleImage4 from "../../../image/for-style-change/for-about/sch-style-abstract-crop-h100.jpeg";
import IpaOutputImage4 from "../../../image/for-style-change/option-description/ipa/turban-woman-output-abstract-ii0.2-h125.jpeg";
import IpaOutputImage5 from "../../../image/for-style-change/option-description/ipa/turban-woman-output-abstract-ii1.0-h125.jpeg";

function StyleChangeDescIpa() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('syleChangeOptions08', 'User needs to add Style image to transfer styles into Input image.')}
          <br/>
          {t('syleChangeOptions09', 'Different output images are genereted based on Style images.')}
          <br/>
          {t('syleChangeOptions10', 'Square image is recommended to use.')}
          <br/>

        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaInputImage}
              />
              {t('aboutPage.13', 'Input image')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaMaskImage}
              />
              {t('aboutStyleChange05', 'Selected part')}
            </div>
          </div>
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaStyleImage1}
              />
                {t('aboutStyleChange06', 'Style image')} (origami)
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaOutputImage1}
              />
                {t('aboutStyleChange07', 'Output image')}
            </div>
        </div>

      </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaStyleImage2}
              />
                {t('aboutStyleChange06', 'Style image')} (oil painting)
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaOutputImage2}
              />
                {t('aboutStyleChange07', 'Output image')}
            </div>
        </div>
      </div>

        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaStyleImage3}
              />
                {t('aboutStyleChange06', 'Style image')} (LEGO block)
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaOutputImage3}
              />
                {t('aboutStyleChange07', 'Output image')}
            </div>
        </div>
      </div>

        <div className="diffsionOptionDescRow">
          <div>
            {t('syleChangeOptions11', 'Image intensity controls strength of Style image.')} 
            {' '}
            {t('syleChangeOptions12', 'Decreasing image intensity reduce effect of Style image and increse effect of other inputs.')}
          </div>
          <br/>

          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaStyleImage4}
              />
                {t('aboutStyleChange06', 'Style image')} (abstract painting)
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaOutputImage4}
              />
                0.2
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaOutputImage5}
              />
                1.0
            </div>
        </div>
      </div>

    </div>
    )
  }


export default StyleChangeDescIpa